import React from 'react';
import { Route, RouteProps } from 'react-router';

type LayoutRouteProps = RouteProps & {
  layout: React.ComponentType;
};

export default function LayoutRoute({
  component: Component,
  layout: Layout,
  ...rest
}: LayoutRouteProps): JSX.Element {
  return (
    <Route
      {...rest}
      render={(routeProps): JSX.Element => (
        <Layout>
          <Component {...routeProps} />
        </Layout>
      )}
    />
  );
}
